import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { useContext } from '../Context'
import { BusyButton } from '@ztechapps/webui.button'

export const SendMessageButton = () => {
  const { onSend, status, message } = useContext()

  const disabled = status?.sending || isEmpty(message)

  return (
    <BusyButton
      onClick={onSend}
      title="Send the message."
      busyText="Sending..."
      isBusy={status?.sending}
      disabled={disabled}
      icon="paper-plane"
      text="Send"
      bsStyle="primary"
    />
  )
}
